Controller = App.loadClass 'core::Angular/Controller'

class exports.MainController extends Controller
    constructor: (@scope, @transitions, @rootScope, @state, @session, @timeout, @interval, @http, @navigationAssistantService) ->
        super

        @rootScope.$on 'unauthorized', () =>
            @session.remove 'Authorization'
            @session.remove 'OriginalUser'
            @state.go 'login'

        # Everything below this deals with the automatic logout and token renewal

        # How many minutes does the token last until expiry?
        # (needs to live on scope so we can init it from the template)
        @scope.sessionLifetimeMinutes = null

        # How many minutes before the token expires should we display the warning message?
        @scope.sessionAlmostEndingMessageMinutes = 15

        # For the Help dropdown and Username dropdown so they don't drop behind the navbar
        @scope.bs2ContainerElement = document.getElementById('bs2-container')

        # After how many minutes should we wait before refreshing the tokens when the user activities?
        @refreshTokenMinutes = 1

        # How often should we update the number of remaining minutes for displaying in the warning message?
        @timeLeftCalculationIntervalSeconds = 5

        # Periodically update the number of minutes remaining for display in the warning message
        @interval @refreshSecondsUntilLogout, @timeLeftCalculationIntervalSeconds * 1000

        @logoutTimer = null

        @scope.registerClick = @registerClick

        # If the page just loaded, then that counts as activity, so refresh the tokens if needed
        @registerClick() if @session.get 'Authorization'

        # Register transition hooks (used by Dusk browser tests)
        window.rootScope = @rootScope
        @rootScope.transitions = []
        @rootScope.isTransitioning = () => @rootScope.transitions.length > 0
        @transitions.onStart null, (trans) =>
            @rootScope.transitions.push trans

        @transitions.onSuccess null, (trans) =>
            # used to communicate certain state changes to navigation assistant
            @navigationAssistantService.angularJSStateChange(trans.to()?.name, trans.from()?.name)
            @rootScope.transitions.pop()

    refreshSecondsUntilLogout: () =>
        @scope.secondsUntilLogout = parseInt(
            @scope.sessionLifetimeMinutes * 60 -
            (new Date().getTime() - @session.get 'AuthTime') / 1000 -
            @timeLeftCalculationIntervalSeconds
        )
        @scope.minutesUntilLogout = parseInt(@scope.secondsUntilLogout / 60)
        #console.log "calculated #{@scope.secondsUntilLogout}s until logout"

        if @scope.secondsUntilLogout > 0 and not @logoutTimer
            @startCountdownTimer()

    startCountdownTimer: () =>
        # Restart the logout timer
        if @logoutTimer?
            @timeout.cancel @logoutTimer

        milliseconds = Math.min(@scope.secondsUntilLogout * 1000, 2147483647)
        # console.log "setting timer for #{@scope.secondsUntilLogout}s (#{milliseconds})"
        @logoutTimer = @timeout () =>
            #console.log 'timer fired, going to logout'
            @state.go 'logout'
            @logoutTimer = null

        # Set the timer to fire when the token expires
        , milliseconds

    registerClick: () =>
        return if not @session.get 'Authorization'
        #console.log 'registered click, checking token lifetime'

        # Check token expiry and renew if it is getting close. If so, renew it.
        #console.log new Date().getTime() - @session.get('AuthTime')
        #console.log @refreshTokenMinutes * 60 * 1000
        if new Date().getTime() - @session.get('AuthTime') > @refreshTokenMinutes * 60 * 1000
            #console.log 'refreshing tokens'
            @http.get "#{Config.get('api_url')}/refreshed-tokens"
            .then (response) =>
                return if @state.current.name is 'context-dependent-registration'

                #console.log 'setting AuthTime to now'
                @session.set 'AuthTime', new Date().getTime()

                @refreshSecondsUntilLogout()

                return if @state.current.name is 'logout'

                #console.log 'tokens refreshed'
                @session.set 'Authorization', "Bearer #{response.data.userToken}"
                @session.set 'SafeLink', "Bearer #{response.data.safeLinkToken}"
                @session.set 'OriginalUser', "Bearer #{response.data.originalUserToken}"
                @startCountdownTimer()
                true
            .catch (error) =>
                @session.remove 'Authorization'
                @session.remove 'SafeLink'
                @session.remove 'OriginalUser'
                @state.go 'login'
